import React from "react";

const Bar = ({ label, value, max }) => {
    const pct = max > 0 ? Math.max(2, (value / max) * 100) : 0;
    return (
        <div className="space-y-1.5">
            <div className="flex items-center justify-between text-[13px]">
                <span className="text-text-secondary">{label}</span>
                <span className="text-text-primary font-medium tabular-nums">
                    {value}
                </span>
            </div>
            <div
                className="h-1.5 w-full overflow-hidden rounded-full"
                style={{ background: "var(--bg-elevated-2)" }}
            >
                <div
                    className="h-full rounded-full"
                    style={{
                        width: `${pct}%`,
                        background:
                            "linear-gradient(90deg, rgba(124,255,79,0.5), rgba(124,255,79,0.85))",
                    }}
                />
            </div>
        </div>
    );
};

const DIVISION_LABEL = {
    funding: "Funding",
    realestate: "Real Estate",
    materials: "Materials",
    consulting: "Consulting",
    contact: "Contact",
};

export const BreakdownBars = ({ stats }) => {
    if (!stats) return null;
    const div = stats.byDivision || {};
    const src = stats.byUtmSource || {};
    const divMax = Math.max(...Object.values(div), 1);
    // Top 6 utm sources + ensure 'direct' is included even if at the bottom
    const srcEntries = Object.entries(src).slice(0, 6);
    const srcMax = Math.max(...srcEntries.map(([, v]) => v), 1);

    return (
        <div
            className="grid grid-cols-1 gap-4 lg:grid-cols-2"
            data-testid="admin-breakdown-bars"
        >
            <div className="rounded-xl border border-border-subtle bg-elevated p-6">
                <p className="text-[11px] uppercase tracking-widest-2 text-text-muted">
                    By Division
                </p>
                <div className="mt-5 space-y-4">
                    {Object.entries(div).map(([k, v]) => (
                        <Bar
                            key={k}
                            label={DIVISION_LABEL[k] || k}
                            value={v}
                            max={divMax}
                        />
                    ))}
                </div>
            </div>
            <div className="rounded-xl border border-border-subtle bg-elevated p-6">
                <p className="text-[11px] uppercase tracking-widest-2 text-text-muted">
                    By UTM Source
                </p>
                <div className="mt-5 space-y-4">
                    {srcEntries.length === 0 && (
                        <p className="text-[13px] text-text-muted">
                            No UTM data yet.
                        </p>
                    )}
                    {srcEntries.map(([k, v]) => (
                        <Bar key={k} label={k} value={v} max={srcMax} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BreakdownBars;
